var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = window.money_format;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }


    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      var qty = 0; // number of products in cart
      var total_price = 0;

      function getItemsInCart(){
        jQuery.getJSON('/cart.js', function (cart, textStatus) {
          qty = cart.item_count;
          total_price = cart.total_price ;
          console.log(Shopify.locale)
          if(Shopify.locale == 'fr'){
          $('.addon-viewcart-ctm').text('Voir le Panier ('+qty+')');
          }else{
            $('.addon-viewcart-ctm').text('View Cart ('+qty+')');
          }
          $('.total-price-addon').text('$'+(total_price/100));
        })
      }
      
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if(window.location.href.indexOf('cart') > -1){
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            document.body.scrollTop = 0; // For Safari
            location.reload();
          }
          console.log(response);
          getItemsInCart();

          var prod_image = response.image;
          var title = response.title;
         
          if (Shopify && Shopify.checkout) {
            qty = Shopify.checkout.line_items.reduce(function(total, item) {
              return total + item.quantity;
            }, 0);
          }
          var var_id = response.variant_id;
          var price = response.price;
          var compare_price = response.compare_at_price;
          var total = price * qty;
          var product_quantity_added = document.querySelector('input[name=quantity]')?.value;
          if(product_quantity_added == undefined){
            product_quantity_added = 1 ;
          }

          $('#addition-products').empty();
          $('#addon-popup .added-popup-product .added-popup-product-left img').attr('src',prod_image);
          $('#addon-popup .added-popup-product .added-popup-product-right h3').text(title);
          $('#addon-popup .added-popup-product .added-popup-product-right .price-sticky .price__container .price__regular .price-item-pro').text(Shopify.formatMoney(price, Shopify.money_format));
          if(compare_price > price){
            $('#addon-popup .added-popup-product .added-popup-product-right .price-sticky .price__container .price__sale .price-item-pro').text(Shopify.formatMoney(compare_price, Shopify.money_format)); 
            $('#addon-popup .added-popup-product .added-popup-product-right .price-sticky .price__container .price__sale').hide();
          }
          $('#addon-popup .added-popup-product .added-popup-product-right .price-sticky .addon-remove').attr('data-var-id',var_id);
          $('#addon-popup .added-popup-product .added-popup-product-right .addon-qty span').text(product_quantity_added);
          $('#addon-popup .addon-subtotal .total-price-addon').text(Shopify.formatMoney(total, Shopify.money_format));
          let home_page_en = window.location.origin + '/en';
          let home_page = window.location.origin + '/';
          if((!response.status && window.location.href.indexOf("collections") > -1)||
          (!response.status && home_page == window.location.href) ||
          (!response.status && home_page_en == window.location.href))
          {
            let popupContainer = document.getElementById('collection-popup-container')
            document.getElementById('addon-popup').style.display = 'block'
            document.getElementById('addon-popup').style.backgroundColor = 'white'
            popupContainer.style.display = 'flex'
            document.querySelector('.fancybox-close-small').addEventListener('click' , ()=>{
              popupContainer.style.display = 'none';
            });
            popupContainer.addEventListener('click' , (event)=>{
              if(popupContainer == event.target){
                popupContainer.style.display = 'none';
              }
            })
          }
          if (response.status) {
            this.handleErrorMessage(response.description);


            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            // window.location = window.routes.cart_url;
            // return;
          }

          console.log('wroking ...');
            var id_arr = [];
            var add_i = 0;
            var len = $('.product__info-container .addon-main li .addon-add_cart.addon-add_cart-active').length;
            var sec_len = $('.addon-desktop-left .addon-main li .addon-add_cart.addon-add_cart-active').length;
            if(len > 0 || sec_len > 0){
             $('.product__info-container .addon-main li .addon-add_cart.addon-add_cart-active, .addon-desktop-left .addon-main li .addon-add_cart.addon-add_cart-active').each(function(e){
               id_arr.push($(this).data('id'));
               
             }) 
             add_to_cart(id_arr);
             function add_to_cart(id_arr){
                var len = id_arr.length;
                if(add_i < len){
                  
                  $.ajax({
                    method: "post",
                    url: "/cart/add.js",
                    data: "id="+id_arr[add_i]+"&quantity=1",
                    dataType: "json",
                    success: function(data){
                      console.log(data);
                      add_i++;
                      add_to_cart(id_arr);
                      getItemsInCart();
                      let discount = 0 ;
                      if(data.original_line_price > data.discounted_price) {
                        discount = data.original_line_price
                      }
                      $('#addition-products').append(`
                      
                      <div style="text-align: center; display:flex; justify-content:center;">
                              <div class="underline"></div>
                      </div>
                      <div class="added-popup-product flex align-item-center">
                      <div class="added-popup-product-left">
                          <img src="${data.image}" alt="{{title | escape }}">
                      </div>
                      <div class="added-popup-product-right">
                        <h3>${ data.product_title }</h3>
                        <div class="price-sticky price-sticky-addon flex align-item-center">
                        <div class="flex align-item-center space-between 
                        price price--on-sale ">
                          <div class="price__container">
                              <div class="price__sale">
                              <span class="price-item-pro price-item--sale-pro price-item--last">
                              $${data.discounted_price /100 + ' CAD'}
                              </span>   
                              <span>
                              <br/>
                              <s class="price-item-pro price-item--regular-compare">${ discount? discount/100 + ' CAD' : '' }
                              </s>
                            </span>
                              </div>
                          </div>
                        
                        </div>
                        <span class="addon-qty">Quantity: 1</span>
                        </div>
                      </div>
                   </div>  
                      `)
                    },
                    error: function(err){
                      console.log(err);
                      add_i++;
                      add_to_cart(id_arr);
                    }
                  })
                }else{
                  add_i = 0;
                  // console.log('successfully update');
                  // var arr_len = id_arr.length;
                  // $('.product__info-container .addon-main li .addon-add_cart').removeClass('addon-add_cart-active');
                  $.getJSON('/cart.js',function(cart){
                    console.log(cart.item_count);
                    $('.header__icon--cart .cart-count-bubble span').text(cart.item_count);
                  //   console.log(cart.items);
                  //   var cart_len = cart.items.length;
                  //   for(var j = 0; j < arr_len;j++){
                  //     var arr_id = id_arr[j];
                  //     for(var i = 0; i < len; i++){
                  //       if(cart.items[i] != undefined){
                  //         console.log(cart.items[i].variant_id);
                  //         if(cart.items[i].variant_id == arr_id){
                  //           $('#addon-popup .addon-add_cart[data-id="'+cart.items[i].variant_id+'"]').addClass('addon-add_cart-active');
                  //           $('.product__info-container .addon-main li .addon-add_cart[data-id="'+cart.items[i].variant_id+'"]').addClass('addon-add_cart-active');
                  //         } 
                  //       }
                  //     } 
                  //   }
                  })
                 if($(evt.submitter).closest('.product__info-wrapper').length > 0){
                   $('.addon-btn')[0].click(); 
                  }
                }
              }
            }else{
             if($(evt.submitter).closest('.product__info-wrapper').length > 0){
               $('.addon-btn')[0].click(); 
              }
            }
          //else{
            //   var arr_len = id_arr.length;
            //   $('.product__info-container .addon-main li .addon-add_cart').removeClass('addon-add_cart-active');
            //   $.getJSON('/cart.js',function(cart){
            //     console.log(cart.items);
            //     var cart_len = cart.items.length;
            //     for(var j = 0; j < arr_len;j++){
            //       var arr_id = id_arr[j];
            //       for(var i = 0; i < len; i++){
            //         if(cart.items[i] != undefined){
            //           console.log(cart.items[i].variant_id);
            //           if(cart.items[i].variant_id == arr_id){
            //             $('#addon-popup .addon-add_cart[data-id="'+cart.items[i].variant_id+'"]').addClass('addon-add_cart-active');
            //             $('.product__info-container .addon-main li .addon-add_cart[data-id="'+cart.items[i].variant_id+'"]').addClass('addon-add_cart-active');
            //           } 
            //         }
            //       } 
            //     }
            //   })
              // if($(evt.submitter).closest('.product__info-wrapper').length > 0){
              //  $('.addon-btn')[0].click(); 
              // }
            // }

          $.getJSON('/cart.js',function(cart){
            var count = cart.item_count;
           $('#cart-icon-bubble .cart-count-bubble > span').text(count);
          })
          
          return;

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
